import {ConfigProvider, Flex, Typography} from "antd"
import {TitleProps} from "antd/es/typography/Title"
import {FC, ReactNode} from "react"

interface Props extends TitleProps {
  title: string,
  extra?: ReactNode
}

export const PageTitle: FC<Props> = ({ title, extra, ...props }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            fontSizeHeading1: 38,
            fontSizeHeading2: 30,
            colorTextHeading: '#192126',
          }
        }
      }}
    >
      <Flex align={'center'} justify={'space-between'} style={{
        position: 'relative'
      }}>
        <Typography.Title
          style={{ margin: '40px 0', ...props.style }}
          level={1 || props.level}
          {...props}
        >
          {title}
        </Typography.Title>
      </Flex>
    </ConfigProvider>
  )
}